<template>
  <Card shadow>
    <p slot="title">
      最新在线人数
      <span class="card-small-title">(每10分钟更新)</span>
    </p>
    <Row type="flex" justify="space-around">
      <Col class="mb-1">
        <div class="home-smallCard-data default">
          <p class="home-smallCard-data-title">总在线人数</p>
          <div class="home-smallCard-data-content">
            <Icon type="md-people" />
            {{allnumber | commaFormat}}
          </div>
        </div>
      </Col>
      <Col class="mb-1" v-for="(it, index) in liveNumber" :key="index">
        <div class="home-smallCard-data" :style="{ background:  colors[index] }">
          <p class="home-smallCard-data-title">{{it.memname}} 在线人数</p>
          <div class="home-smallCard-data-content">
            <Icon type="md-people" />
            {{it.data[0].onlinememcou | commaFormat}}
          </div>
        </div>
      </Col>
    </Row>
  </Card>
</template>
<script>
export default {
  name: 'ChartsLiveNumber',
  data () {
    return {
      colors: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
      liveNumber: [],
      liveNumberTime: null,
    }
  },
  computed: {
    allnumber () {
      if (!this.liveNumber.length) return 0
      return this.liveNumber.reduce((acc, val) => acc += val.data[0].onlinememcou, 0)
    }
  },
  created () {
    this.linkinonlinemem()
    this.liveNumberTime = setInterval(() => {
      this.linkinonlinemem()
    }, 600000)
  },
  beforeDestor () {
    clearInterval(this.liveNumberTime)
  },
  methods: {
    async linkinonlinemem () {
      try {
        const res = await this.$axios.linkinonlinemem()
        if ('status' in res && res.status === 0) return
        this.liveNumber = res
      } catch (error) {
        console.error(error);
      }
    },
  }
}
</script>
<style lang="scss">
.card-small-title {
  font-size: 12px;
  color: #888888;
}
</style>